/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "CraScheduleModal",

  components: {
    customModal
  },

  emits: ["closeModal", "saved"],

  props: {
    editingId: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      loading: false,

      formData: {
        craScheduleId: "",
        studyId: "",
        siteId: "",
        siteCode: "",
        craId: "",
        plannedDate: "",
        status: ""
      }
    };
  },

  watch: {
    editingId: {
      immediate: true,
      async handler(newId) {
        if (!newId) return;
        if (!this.token) return;

        this.formData.craScheduleId = newId;
        await this.fetchCraSchedule();
      }
    }
  },

  async mounted() {
    this.token = store.getters.getIdToken;
    this.formData.studyId = store.getters.getStudyIs;

    if (this.editingId) {
      this.formData.craScheduleId = this.editingId;
    }

    await this.fetchCraSchedule();
  },

  methods: {
    async fetchCraSchedule() {
      try {
        this.loading = true;

        const res = await axios.get(
          `${this.baseurl}/forms/cra/getbyid?id=${this.editingId}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json"
            }
          }
        );

        const data = res.data;
        const possibleId = data.craScheduleId || data.id || data.craScheduleID || data.scheduleId;

        this.formData = {
          craScheduleId: this.editingId || possibleId,
          studyId: data.studyId || "",
          siteId: data.siteId || "",
          siteCode: data.siteCode || "",
          craId: data.craId || "",
          plannedDate: data.plannedDate ? data.plannedDate.split("T")[0] : "",
          immediateDate: data.immediateDate ? data.immediateDate.split("T")[0] : "",
          status: data.status || ""
        };

      } catch (err) {
        alert("Failed to load CRA schedule details");
      } finally {
        this.loading = false;
      }
    },

    async updateCraSchedule() {
      try {
        const craScheduleId = this.formData.craScheduleId || this.editingId;

        if (!craScheduleId) {
          alert("Cannot update: Missing schedule ID");
          return;
        }

        const payload = {
          lastModifiedUserEmail: store.getters.getUserEmail,
          lastModifiedUserId: store.getters.getUserId,
          lastModifiedAt: new Date().toISOString(),
          craScheduleId: craScheduleId,
          studyId: this.formData.studyId,
          siteId: this.formData.siteId,
          siteCode: this.formData.siteCode,
          craId: this.formData.craId,
          plannedDate: this.formData.plannedDate
            ? new Date(this.formData.plannedDate).toISOString()
            : null,
          immediateDate: this.formData.immediateDate
            ? new Date(this.formData.immediateDate).toISOString()
            : null,
          status: this.formData.status || ""
        };

        await axios.put(
          `${this.baseurl}/forms/cra/updatecraschedule`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json"
            }
          }
        );

        alert("CRA Schedule updated successfully");
        this.$emit("saved");
        this.closeModal();

      } catch (err) {
        alert(err.response?.data?.message || "Update failed");
      }
    },

    closeModal() {
      this.$emit("closeModal");
    }
  }
};